<template>
  <div class="card my-4 mx-3 p-2 shadow-sm search-bar-card">
    <div 
      class="d-flex align-items-center justify-content-between px-2 cursor-pointer"
      @click="isCollapsed = !isCollapsed"
    >
      <div>
        <b-icon 
          icon="stars" 
          scale="1"
          class="icon-size"
        />
        <span class="text-muted font-semibold">AI Assistant</span>
      </div>
      <i 
        class="bi cursor-pointer" 
        :class="!isCollapsed ? 'bi-chevron-up' : 'bi-chevron-down'"
      />
    </div>
    <b-collapse 
      :visible="!isCollapsed"
      class="px-2 mb-3"
    >
      <div class="title-container d-flex align-items-center mb-2 mt-4">
        <div class="rounded-circle stars-icon d-flex align-items-center justify-content-center p-3 mr-2">
          <b-icon 
            icon="stars" 
            scale="1.5"
            class="icon-size"
          />
        </div>
        <div>
          <strong style="color: #101828;">
            What do you want to create?
          </strong>
          <p class="title-text mb-2">
            Describe a campaign, layout or placement to get started
          </p>
        </div>
      </div>
      <div class="w-100">
        <div class="ai-agent-chat-wrapper">
          <div class="d-flex align-items-center space-x-2">
            <input
              ref="promptTextarea"
              v-model="prompt"
              class="form-control ai-agent-input flex-grow-1 mr-2"
              placeholder="e.g Create a Walmart Connect campaign"
              rows="1"
              @keyup.enter="sendMessage"
            >
            <button
              type="button"
              class="btn btn-primary d-flex align-items-center justify-content-center"
              :disabled="isSendingMessage"
              aria-label="Send"
              @click="sendMessage"
            >
              <span
                v-if="isSendingMessage"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              <i 
                v-else 
                class="cil-send" 
              />
            </button>
          </div>
        </div>
      </div>
      <div class="common-search d-flex align-items-center mt-3 flex-wrap gap-2">
        <button
          v-for="(suggestion, index) in suggestions"
          :key="index"
          type="button"
          class="walmart-btn"
          @click="useSuggestion(suggestion)"
        >
          {{ suggestion }}
        </button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'AiSearchBar',
  data: () => ({
    isSendingMessage: false,
    prompt: '',
    isCollapsed: true,
    suggestions: [
        'Create a Walmart Connect onsite campaign',
        'New Amazon Ads placement set',
        'Build a Roundel campaign for Target',
        'Create Dollar General banners',
        'Set up Hy-Vee Ads'
      ]
  }),
  methods: {
    sendMessage() {
      if (this.isSendingMessage) {
        return;
      }

      if (this.prompt.trim() === '') {
        toastr.error('Please enter a message');
        return;
      }

      if (typeof window.startNewAiAgentTask !== 'function') {
        toastr.error('AI Assistant is not available right now');
        return;
      }

      this.isSendingMessage = true;
      window.startNewAiAgentTask(this.prompt.trim());
      this.prompt = '';

      // Re-enable the send button once the agent sidebar has taken over.
      setTimeout(() => {
        this.isSendingMessage = false;
      }, 3000);
    },
    useSuggestion(text) {
      this.prompt = text;
    },
  }
}
</script>
<style scoped>
.title-text {
    color: #6c757d !important;
    font-size: 14px;
}
.ai-agent-input {
    background-color: #f6f6f6 !important;
}
.search-bar-card {
    border-radius: 10px !important;
}
.stars-icon {
    background-color: #f6f6f6;
}
.common-search .walmart-btn {
    background-color: #209c86;
}
.walmart-btn {
  background: #209c86;
  color: #fff;
  border: none;
  border-radius: 9999px;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.walmart-btn:hover {
  filter: brightness(0.96);
}
.cursor-pointer {
  cursor: pointer;
}
</style>
